module.exports = __webpack_public_path__ + "img/taginfo.367267df.png";